

import ClevertapReact from 'clevertap-web';

let initializeCleverTap = () => {
  ClevertapReact.initialize('649-47W-Z55Z');
}

async function pushEventToCleverTap(event, payload){
   ClevertapReact.event(event, payload);
}
let pushProfileToCleverTap = ( payload) => {
  ClevertapReact.onUserLogin(payload)
}


export  {
  initializeCleverTap,
  pushEventToCleverTap,
  pushProfileToCleverTap
}

